import React, { useState, useEffect, useRef } from 'react';
import { Typography, Tabs, Card, Col, Row, message, Button, Spin, notification } from 'antd';
// import { useParams } from 'react-router-dom';
import RelatedRecord from './RelatedRecords';
import { useLocation } from 'react-router-dom';
import { BASE_URL } from '../Components/Constant';
import ApiService from '../Components/apiService'; // Import ApiService class
import ActivityComponent from '../Activity/ActivityComponent';
import RecordDetails from './RecordDetail'; // Import the new RecordDetails component
import CompactLayout from './CompactLayoutDisplay';
import RecordPath from './RecordPath';
import ApprovalTab from '../ApprovalRequest/ApprovalRecordTab';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import eventBus from "../Components/eventBus";

const { Title } = Typography;
const { TabPane } = Tabs;

const RecordDetail = ({ id, objectName }) => {
  const location = useLocation();
  // const { id, objectName } = useParams();
  const { objectid } = location.state || '';
  const [record, setRecord] = useState({});
  const [compactlayout, setCompactLayout] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allowApprovals, setAllowApprovals] = useState(false);
  const [allowActivty, setAllowActivity] = useState(false);
  const [fields, setFields] = useState([]);
  const [picklistValues, setPicklistValues] = useState([]); // For picklist values
  const [isValueUpdated, setIsValueUpdated] = useState(false);
  const [newStatus, setNewStatus] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [recordPathField, setRecordPathField] = useState(null);
  const [actionButtons, setActionButtons] = useState([]);
  const [layout, setLayout] = useState([]);
  const functionRef = useRef(null);
  const navigate = useNavigate();
  const security = useSelector((state) => state.data.items[0]);
  // const [ loading, setLoading ] = useState(false);  
  const [activeCurrencies, setActiveCurrencies] = useState([]);
  const [currentSelectedValue, setCurrentSelectedValue] = useState([]);


  useEffect(() => {
    fetchCurrency();
    const handleLoadingStart = () => {
      setLoading(true)
    };
    const handleLoadingEnd = () => {
      setLoading(false);
    }

    eventBus.on("loadingStart", handleLoadingStart);
    eventBus.on("loadingEnd", handleLoadingEnd);

    return () => {
      eventBus.off("loadingStart", handleLoadingStart);
      eventBus.off("loadingEnd", handleLoadingEnd);
    };
  }, []);


  useEffect(() => {
    if (record) {
      fetchMetadata();
    }
  }, [record]);


  useEffect(() => {
    if (record && recordPathField && picklistValues.length > 0) {
      const fieldMeta = fields.find(f => f._id === recordPathField);
      const fieldApiName = fieldMeta?.name;
      // const fieldMeta = fields.find(f => f._id === recordPathField);
      // const fieldApiName = fieldMeta?.name;

      setCurrentSelectedValue(record[fieldApiName]);
      console.log('fieldApiName::', fieldApiName);


      // setCurrentFieldApiName(fieldApiName);
      const currentValue = record[fieldApiName];
      console.log('record:', record);
      console.log('currentValue:', currentValue);
      const index = picklistValues.findIndex((val) => val === currentValue);
      if (index !== -1) {
        setSelectedIndex(index);
      } else {
        setSelectedIndex(null);
      }
    }
  }, [record, recordPathField, picklistValues]);
  useEffect(() => {
    fetchRecords();
  }, [id])

  const fetchCurrency = async () => {
    try {

      const apiService = new ApiService(`${BASE_URL}/mt_currencies`, {
        'Content-Type': 'application/json',
      }, 'GET');
      const response = await apiService.makeCall();
      console.log('responseresponse:', response);
      setActiveCurrencies(response);
    } catch (err) {
      console.error("Error fetching metadata:", err);
    }
  }
  const getConvertedValue = (amount, fromCode, toCode) => {
    const parsedAmount = parseFloat(amount);

    // Check for invalid or empty amount
    if (isNaN(parsedAmount) || fromCode === toCode) {
      return isNaN(parsedAmount) ? '0.00' : parsedAmount.toFixed(2);
    }

    const fromCurrency = activeCurrencies.find(c => c.iso_code === fromCode);
    const toCurrency = activeCurrencies.find(c => c.iso_code === toCode);

    if (!fromCurrency || !toCurrency || !fromCurrency.conversion_rate || !toCurrency.conversion_rate) {
      return '0.00';
    }

    const inCorporate = parsedAmount / fromCurrency.conversion_rate;
    const converted = inCorporate * toCurrency.conversion_rate;

    return converted.toFixed(2);
  };
  const fetchRecords = async () => {
    setLoading(true);
    try {
      const apiService = new ApiService(`${BASE_URL}/fetch_single_record/${objectName}/${id}`, {}, 'GET');
      const responseData = await apiService.makeCall(navigate);
      setRecord(responseData);
    }
    catch (error) {

    } finally {
      setLoading(false);
    }

  }
  const fetchMetadata = async () => {
    setLoading(true);
    try {
      // Step 1: Fetch object metadata
      const apiServiceObj = new ApiService(`${BASE_URL}/get_mt_object_by_name/${objectName}`, {}, 'GET');
      const responseOb = await apiServiceObj.makeCall();
      setAllowApprovals(responseOb[0].allow_approvals);
      setAllowActivity(responseOb[0].track_activities);

      // Step 2: Fetch field metadata
      const apiService = new ApiService(`${BASE_URL}/mt_fields/object/${objectName}`, {}, 'GET');
      const response = await apiService.makeCall();
      setFields(response);

      let detailLayoutAndActionButtons = [];

      // Step 3: Fetch layout based on RecordType or fallback
      if (record?.RecordType) {
        const layoutService = new ApiService(
          `${BASE_URL}/get_layout_by_record_type/${objectName}/${record.RecordType}`,
          {},
          'GET'
        );
        const layoutResponse = await layoutService.makeCall();

        // No need to check `.active` here; it's already a single active layout
        detailLayoutAndActionButtons = [layoutResponse];
      } else {
        const fallbackLayoutService = new ApiService(
          `${BASE_URL}/get_by_objectName/${objectName}`,
          {},
          'GET'
        );
        const fallbackResponse = await fallbackLayoutService.makeCall();

        // Here you filter only active layouts
        detailLayoutAndActionButtons = (Array.isArray(fallbackResponse) ? fallbackResponse : [fallbackResponse])
          .filter(layout => layout.active);
      }

      console.log('finalLayoutAndButtons::', detailLayoutAndActionButtons);
      console.log('record.rectyepee::', record.RecordType);
      setLayout(detailLayoutAndActionButtons);

      setActionButtons(detailLayoutAndActionButtons[0]?.action_button_ids || []);

      // Step 5: Fetch compact layout info
      const compactLayoutService = new ApiService(`${BASE_URL}/get_compact_layout/${objectName}`, {}, 'GET');
      const res = await compactLayoutService.makeCall();
      setRecordPathField(res?.record_path_field);

      const picklistField = response.find(field => field?._id === res?.record_path_field);
      setPicklistValues(picklistField?.picklist_values || []);
      setCompactLayout(res || []);
    } catch (err) {
      console.error('Error fetching records', err);
    } finally {
      setLoading(false);
    }
  };


  const cancelSelectedValue = () => {
    setNewStatus('');
    setIsValueUpdated(false);
    setSelectedIndex(null);
  }
  const completeStep = (newStatus) => {
    setNewStatus(newStatus);
    setIsValueUpdated(true);
  }
  // Update record status
  const updateStatus = async (targetIndex) => {
    setLoading(true);
    setIsValueUpdated(false);
    try {
      if (targetIndex >= picklistValues.length || targetIndex < 0) {
        message.error('No more steps to complete');
        return;
      }

      const newStatus = picklistValues[targetIndex];
      const fieldMeta = fields.find(f => f._id === recordPathField);
      const fieldApiName = fieldMeta?.name;

      if (!fieldApiName) {
        message.error("Field API name not found for record path field");
        return;
      }

      const body = {
        object_name: objectName,
        data: {
          _id: record._id || "",
          [fieldApiName]: newStatus,
        },
      };


      const apiService = new ApiService(
        `${BASE_URL}/insert_or_update_records`,
        { 'Content-Type': 'application/json' },
        'POST',
        body
      );
      await apiService.makeCall();

      completeStep(newStatus);
      await fetchRecords();

      message.success('Status updated successfully');
    } catch (error) {
      message.error('Error updating status');
    } finally {
      setLoading(false);
      setSelectedIndex(null);
    }
  };



  return (
    <div style={{ display: 'flex', gap: '4px', flexDirection: 'column', height: '100%', padding: '4px', position: 'relative' }}>

      <CompactLayout
        setFunctionRef={(fn) => (functionRef.current = fn)}
        actionButtons={actionButtons}
        setActionButtons={setActionButtons}
        id={id}
        objName={objectName}
        compactlayout={compactlayout}
        record={record}
        object={objectName}
        allowApprovals={allowApprovals}
        fields={fields}
        setRecordData={setRecord}
        fetchRecordData={fetchRecords}
        fetchCurrency={fetchCurrency}
        getConvertedValue={getConvertedValue}

      />


      {loading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(255, 255, 255, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <Spin size="large" />
        </div>
      )}

      {picklistValues.length > 0 ? (
        <RecordPath
          picklistValues={picklistValues}
          currentStatus={currentSelectedValue}
          completeStep={completeStep}
          setSelectedIndex={setSelectedIndex}
          selectedIndex={selectedIndex}
          isValueUpdated={isValueUpdated}
          cancelSelectedValue={cancelSelectedValue}
          updateStatus={updateStatus}
          objectName={objectName}
          fieldName={fields.find(f => f._id === recordPathField)?.name}
        />
      ) : (
        console.log('No Picklist Field Values!!')
      )}
      <div style={{ backgroundColor: "white", borderRadius: 7, padding: 10, border: "1px solid rgb(239, 239, 239)", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }}>

        <Tabs defaultActiveKey="1" style={{ marginLeft: 2, marginRight: 2, padding: 0 }}>
          <TabPane tab="Detail" key="1">
            {record && Object.keys(record).length > 0 && (
              <RecordDetails
                objectName={objectName}
                id={id}
                fetchRecordData={fetchRecords}
                recordDetails={record}
                Recordfields={fields}
                actionButtons={actionButtons}
                setActionButtons={setActionButtons}
                layout={layout}
                fetchCurrency={fetchCurrency}
                getConvertedValue={getConvertedValue}
              />
            )}
          </TabPane>
          <TabPane tab="Related" key="2">
            <RelatedRecord
              objectName={objectName}
              recordDetails={record}
              recordId={id}
              fields={fields}
            />
          </TabPane>
          {allowActivty && security?.object_settings?.["Activity"]?.object_setting?.view === true && (
            <TabPane tab="Activity" key="3">
              <ActivityComponent objectName={objectName} recordId={id} />
            </TabPane>
          )}
          {allowApprovals && (
            <TabPane tab="Approvals" key="4">
              <ApprovalTab
                functionRef={functionRef.current}
                object={objectName}
                recordId={id}
                setRecordData={setRecord}
                fetchRecordData={fetchRecords}
              />
            </TabPane>
          )}
        </Tabs>
      </div>
    </div>
  );

};

export default RecordDetail; 